<template>
  <v-app-bar elevation="1" app class="pr-3" height="75">
    <!-- Logo Section -->
    <div class="d-flex align-center mr-6" v-if="!isLoading">
      <div class="hidden-xs-only">
        <v-img
          :src="require('@/assets/eye_staff_logo.png')"
          height="60"
          width="150"
          contain
          aspect-ratio="2.5"
          :style="{ 'background-color': isDarkmodeEnabled ? 'white' : '' }"
        />
      </div>
    </div>

    <v-spacer />

    <!-- Username -->
    <div class="d-flex align-center mr-4">
      <span>{{ username }}</span>
    </div>

    <!-- User Menu -->
    <v-menu location="bottom end">
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props">
          <v-icon :icon="menuIcon" />
        </v-btn>
      </template>

      <v-list style="min-width: 300px; overflow-x: hidden">
        <v-list-item v-for="item in listItems" :key="item.id" @click="onButtonClick(item.id)" :prepend-icon="item.icon">
          <v-list-item-title>{{ item.label }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script setup>
import { computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useTheme } from 'vuetify';
import {
  mdiLogoutVariant,
  mdiMenu,
  mdiAccountCogOutline,
  mdiWeatherSunny,
  mdiWeatherNight,
  mdiFileDocument,
  mdiOpenInNew,
} from '@mdi/js';
import { auth } from '../../boots/firebase';

const store = useStore();
const theme = useTheme();

// Constants
const menuIcon = mdiMenu;
const ressourcesIcon = mdiFileDocument;
const externalLinkIcon = mdiOpenInNew;
const links = [{ text: 'Admin', to: '/', icon: mdiAccountCogOutline }];

// Computed properties
const username = computed(() => store.state.auth.username);
const isAutoPlayEnabled = computed(() => store.state.userPreferences.autoPlay);
const isDarkmodeEnabled = computed(() => store.state.userPreferences.darkmode);
const isLoading = computed(() => store.state.organizations.isLoading);

const listItems = computed(() => [
  {
    icon: isDarkmodeEnabled.value ? mdiWeatherNight : mdiWeatherSunny,
    label: `${isDarkmodeEnabled.value ? 'Désactiver' : 'Activer'} le mode nuit`,
    color: isDarkmodeEnabled.value ? 'black' : 'yellow',
    id: 'darkmode',
  },
  {
    icon: mdiLogoutVariant,
    label: 'Logout',
    color: 'error',
    id: 'logout',
  },
]);

// Methods
const onButtonClick = (id) => {
  if (id === 'darkmode') {
    store.commit('userPreferences/TOGGLE_DARKMODE');
    // Theme will be updated automatically through the watcher
  } else if (id === 'logout') {
    auth.signOut().then(
      () => {
        document.location = '/';
      },
      () => {
        // console.error(err);
      },
    );
  }
};

// Watchers
watch(
  isDarkmodeEnabled,
  (newValue) => {
    // Sync theme with store state - Vuetify 3 correct syntax using theme.global.name
    theme.global.name.value = newValue ? 'dark' : 'light';
  },
  { immediate: true }, // Run on component creation
);

// Lifecycle
onMounted(() => {
  if (!store.state.organizations.isInitialized && !store.state.auth.claims.superAdmin) {
    store.dispatch('organizations/getCurrentUserOrg');
  }
});
</script>

<style scoped>
.v-app-bar {
  display: flex !important;
  align-items: center !important;
}

.toolbar-nav-btn {
  height: 48px;
  margin: 0 4px;
}

.v-img {
  vertical-align: middle;
}

/* Ensure all elements are properly aligned */
.d-flex.align-center {
  height: 100%;
  display: flex;
  align-items: center;
}

/* Username styling */
.text-body-1 {
  font-weight: 500;
  white-space: nowrap;
}

/* Menu positioning */
.v-menu {
  z-index: 1000;
}
</style>
